import { Moon, Sun } from "lucide-react";

import { Button } from "@/components/ui/button";
import { resolveDark, useThemeStore } from "@/lib/theme";
import { cn } from "@/lib/utils";

/** Bascule rapide clair/sombre, accessible dans la navbar. Fixe une préférence
 *  explicite (light/dark) au clic. Le réglage fin (dont « Système ») reste dans
 *  Profil → Apparence. `className` permet de réutiliser le contrôle hors navbar
 *  (ex. drawer mobile sur fond clair). */
export function ThemeToggle({ className }: { className?: string }) {
  const preference = useThemeStore((s) => s.preference);
  const setPreference = useThemeStore((s) => s.setPreference);
  const isDark = resolveDark(preference);

  return (
    <Button
      variant="ghost"
      size="icon"
      aria-label={isDark ? "Passer en mode clair" : "Passer en mode sombre"}
      title={isDark ? "Mode clair" : "Mode sombre"}
      onClick={() => setPreference(isDark ? "light" : "dark")}
      className={cn(
        "text-primary-foreground hover:bg-primary-foreground/10 hover:text-primary-foreground",
        className,
      )}
    >
      {isDark ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
    </Button>
  );
}
